var _path, _rect, _rect2, _ellipse, _path2, _path3, _path4, _path5, _path6, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _mask, _rect20, _mask2, _rect21, _mask3, _rect22, _mask4, _rect23, _mask5, _rect24, _mask6, _rect25, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect26, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToolDirectionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 551,
    height: 595,
    viewBox: "0 0 551 595",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.605 474.9C518.217 424.726 551 353.941 551 275.5C551 123.346 427.654 0 275.5 0C123.346 0 0 123.346 0 275.5C0 353.941 32.7827 424.726 85.3947 474.9H465.605Z",
    fill: "#024F91",
    fillOpacity: 0.15
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 206.146,
    y: 84.7688,
    width: 29.8619,
    height: 396.874,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 209.105,
    y: 87.7278,
    width: 23.9438,
    height: 390.956,
    stroke: "black",
    strokeOpacity: 0.8,
    strokeWidth: 5.91808
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 222.04,
    cy: 80.9165,
    rx: 30.3435,
    ry: 30.8252,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M249.424 80.9165C249.424 96.3506 237.12 108.783 222.04 108.783C206.96 108.783 194.655 96.3506 194.655 80.9165C194.655 65.4823 206.96 53.0504 222.04 53.0504C237.12 53.0504 249.424 65.4823 249.424 80.9165Z",
    stroke: "black",
    strokeOpacity: 0.8,
    strokeWidth: 5.91808
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M322.956 129.08H236.005V182.061H322.956L349.673 155.571L322.956 129.08Z",
    fill: "#024F91"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M325.039 126.979L324.174 126.121H322.956H236.005H233.046V129.08V182.061V185.02H236.005H322.956H324.174L325.039 184.162L351.756 157.672L353.875 155.571L351.756 153.469L325.039 126.979Z",
    stroke: "black",
    strokeOpacity: 0.8,
    strokeWidth: 5.91808
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.194 209.033H206.146V156.053H119.194L92.4777 182.543L119.194 209.033Z",
    fill: "#024F91"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.111 211.135L117.976 211.992H119.194H206.146H209.105V209.033V156.053V153.094H206.146H119.194H117.976L117.111 153.951L90.3942 180.442L88.275 182.543L90.3942 184.644L117.111 211.135Z",
    stroke: "black",
    strokeOpacity: 0.8,
    strokeWidth: 5.91808
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.85645,
    y: 474.9,
    width: 461.414,
    height: 12.5227,
    rx: 6.26136,
    fill: "#313131"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 279.933,
    y: 264.561,
    width: 206.669,
    height: 297.209,
    transform: "rotate(7 279.933 264.561)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 275.581,
    y: 258.992,
    width: 216.664,
    height: 307.204,
    transform: "rotate(7 275.581 258.992)",
    stroke: "black",
    strokeOpacity: 0.8,
    strokeWidth: 9.99499,
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 329.084,
    y: 413.377,
    width: 110.223,
    height: 3.93655,
    transform: "rotate(7 329.084 413.377)",
    fill: "#024F91"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 327.886,
    y: 423.146,
    width: 110.223,
    height: 3.93655,
    transform: "rotate(7 327.886 423.146)",
    fill: "black",
    fillOpacity: 0.8
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 324.285,
    y: 452.449,
    width: 110.223,
    height: 3.93655,
    transform: "rotate(7 324.285 452.449)",
    fill: "#024F91"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 323.087,
    y: 462.217,
    width: 110.223,
    height: 3.93655,
    transform: "rotate(7 323.087 462.217)",
    fill: "black",
    fillOpacity: 0.8
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 321.889,
    y: 471.986,
    width: 37.3972,
    height: 3.93655,
    transform: "rotate(7 321.889 471.986)",
    fill: "black",
    fillOpacity: 0.8
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 316.37,
    y: 516.919,
    width: 110.223,
    height: 3.93655,
    transform: "rotate(7 316.37 516.919)",
    fill: "black",
    fillOpacity: 0.8
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 317.568,
    y: 507.15,
    width: 110.223,
    height: 3.93655,
    transform: "rotate(7 317.568 507.15)",
    fill: "black",
    fillOpacity: 0.8
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 318.767,
    y: 497.383,
    width: 64.953,
    height: 3.93655,
    transform: "rotate(7 318.767 497.383)",
    fill: "#024F91"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 340.843,
    y: 317.651,
    width: 110.223,
    height: 3.93655,
    transform: "rotate(7 340.843 317.651)",
    fill: "#024F91"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 339.645,
    y: 327.419,
    width: 110.223,
    height: 3.93655,
    transform: "rotate(7 339.645 327.419)",
    fill: "black",
    fillOpacity: 0.8
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 338.446,
    y: 337.187,
    width: 64.953,
    height: 3.93655,
    transform: "rotate(7 338.446 337.187)",
    fill: "black",
    fillOpacity: 0.8
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 332.928,
    y: 382.119,
    width: 110.223,
    height: 3.93655,
    transform: "rotate(7 332.928 382.119)",
    fill: "black",
    fillOpacity: 0.8
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 334.126,
    y: 372.351,
    width: 84.6358,
    height: 3.93655,
    transform: "rotate(7 334.126 372.351)",
    fill: "black",
    fillOpacity: 0.8
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 335.322,
    y: 362.583,
    width: 84.6358,
    height: 3.93655,
    transform: "rotate(7 335.322 362.583)",
    fill: "#024F91"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-27-inside-1_352_10922",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 296.384,
    y: 308.225,
    width: 31.4924,
    height: 31.4924,
    rx: 1.42786,
    transform: "rotate(7 296.384 308.225)"
  }))), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 296.384,
    y: 308.225,
    width: 31.4924,
    height: 31.4924,
    rx: 1.42786,
    transform: "rotate(7 296.384 308.225)",
    stroke: "black",
    strokeWidth: 4.28357,
    strokeLinejoin: "round",
    mask: "url(#path-27-inside-1_352_10922)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-28-inside-2_352_10922",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 296.384,
    y: 308.225,
    width: 31.4924,
    height: 31.4924,
    rx: 1.42786,
    transform: "rotate(7 296.384 308.225)"
  }))), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 296.384,
    y: 308.225,
    width: 31.4924,
    height: 31.4924,
    rx: 1.42786,
    transform: "rotate(7 296.384 308.225)",
    stroke: "black",
    strokeWidth: 4.28357,
    strokeLinejoin: "round",
    mask: "url(#path-28-inside-2_352_10922)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-29-inside-3_352_10922",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.868,
    y: 353.159,
    width: 31.4924,
    height: 31.4924,
    rx: 1.42786,
    transform: "rotate(7 290.868 353.159)"
  }))), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 290.868,
    y: 353.159,
    width: 31.4924,
    height: 31.4924,
    rx: 1.42786,
    transform: "rotate(7 290.868 353.159)",
    stroke: "black",
    strokeWidth: 4.28357,
    strokeLinejoin: "round",
    mask: "url(#path-29-inside-3_352_10922)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-30-inside-4_352_10922",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 285.353,
    y: 398.091,
    width: 31.4924,
    height: 31.4924,
    rx: 1.42786,
    transform: "rotate(7 285.353 398.091)"
  }))), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 285.353,
    y: 398.091,
    width: 31.4924,
    height: 31.4924,
    rx: 1.42786,
    transform: "rotate(7 285.353 398.091)",
    stroke: "black",
    strokeWidth: 4.28357,
    strokeLinejoin: "round",
    mask: "url(#path-30-inside-4_352_10922)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-31-inside-5_352_10922",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 279.832,
    y: 443.025,
    width: 31.4924,
    height: 31.4924,
    rx: 1.42786,
    transform: "rotate(7 279.832 443.025)"
  }))), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 279.832,
    y: 443.025,
    width: 31.4924,
    height: 31.4924,
    rx: 1.42786,
    transform: "rotate(7 279.832 443.025)",
    stroke: "black",
    strokeWidth: 4.28357,
    strokeLinejoin: "round",
    mask: "url(#path-31-inside-5_352_10922)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-32-inside-6_352_10922",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274.314,
    y: 487.957,
    width: 31.4924,
    height: 31.4924,
    rx: 1.42786,
    transform: "rotate(7 274.314 487.957)"
  }))), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 274.314,
    y: 487.957,
    width: 31.4924,
    height: 31.4924,
    rx: 1.42786,
    transform: "rotate(7 274.314 487.957)",
    stroke: "black",
    strokeWidth: 4.28357,
    strokeLinejoin: "round",
    mask: "url(#path-32-inside-6_352_10922)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M299.243 317.264L307.671 333.408L330.557 304.489",
    stroke: "#024F91",
    strokeWidth: 4.28357,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M293.964 360.244L302.393 376.388L325.279 347.469",
    stroke: "#024F91",
    strokeWidth: 4.28357,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M288.206 407.13L296.635 423.274L319.521 394.355",
    stroke: "#024F91",
    strokeWidth: 4.28357,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M415.176 261.337L415.176 261.337L431.698 263.366C461.374 267.009 464.441 287.217 462.266 296.865L304.128 277.448C307.57 249.418 334.083 251.38 350.677 253.418L356.568 254.141L356.568 254.14C358.29 240.114 372.806 230.354 388.99 232.342C405.175 234.329 416.898 247.31 415.176 261.337ZM385.632 259.692C388.869 260.089 391.815 257.787 392.212 254.55C392.61 251.314 390.308 248.367 387.071 247.97C383.834 247.573 380.888 249.874 380.491 253.111C380.093 256.348 382.395 259.294 385.632 259.692Z",
    fill: "#024F91"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.308 0.800049L35.6173 15.871L50.6882 25.1803L35.6173 34.4896L26.308 49.5606L16.9987 34.4896L1.92773 25.1803L16.9987 15.871L26.308 0.800049Z",
    fill: "#024F91"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M512.173 108.77L521.483 123.84L536.553 133.15L521.483 142.459L512.173 157.53L502.864 142.459L487.793 133.15L502.864 123.84L512.173 108.77Z",
    fill: "#024F91"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7884 370.865L24.4896 380.095L33.7193 385.796L24.4896 391.497L18.7884 400.727L13.0872 391.497L3.85742 385.796L13.0872 380.095L18.7884 370.865Z",
    fill: "#024F91"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M503.098 353.527L509.082 363.215L518.771 369.2L509.082 375.184L503.098 384.873L497.113 375.184L487.425 369.2L497.113 363.215L503.098 353.527Z",
    fill: "#024F91"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M421.617 14.7319L425.606 21.1909L432.065 25.1806L425.606 29.1703L421.617 35.6293L417.627 29.1703L411.168 25.1806L417.627 21.1909L421.617 14.7319Z",
    fill: "#024F91"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 18.3057,
    y: 461.415,
    width: 157.016,
    height: 97.292,
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.4912 443.844C80.7898 445.856 80.0143 448.009 78.3404 449.929H41.7095V443.844H18.9013V449.958C9.43494 450.483 1.92773 457.989 1.92773 467.17V549.318C1.92773 558.84 10.002 566.559 19.9621 566.559H78.1834C87.6466 573.855 99.6829 578.222 112.786 578.222C125.889 578.222 137.926 573.855 147.389 566.559H174.315C184.275 566.559 192.35 558.84 192.35 549.318V467.17C192.35 457.648 184.275 449.929 174.315 449.929H138.886C137.536 447.898 136.09 445.011 134.799 441.309C132.889 435.832 126.224 435.139 123.129 435.477H90.2432C84.1556 435.477 83.0288 439.035 81.9359 442.485C81.7909 442.943 81.6465 443.399 81.4912 443.844ZM112.786 569.602C139.151 569.602 160.524 549.169 160.524 523.964C160.524 498.759 139.151 478.326 112.786 478.326C86.4212 478.326 65.0481 498.759 65.0481 523.964C65.0481 549.169 86.4212 569.602 112.786 569.602ZM112.786 556.417C131.535 556.417 146.733 541.887 146.733 523.964C146.733 506.04 131.535 491.51 112.786 491.51C94.0377 491.51 78.8391 506.04 78.8391 523.964C78.8391 541.887 94.0377 556.417 112.786 556.417ZM140.633 532.006C141.694 529.978 145.142 522.118 138.246 511.976C139.573 523.639 137.186 534.288 125.516 541.133C134.799 540.88 139.573 534.034 140.633 532.006ZM37.6352 471.782C40.9216 471.782 43.5858 474.446 43.5858 477.733V549.141C43.5858 552.428 40.9216 555.092 37.6352 555.092C34.3487 555.092 31.6845 552.428 31.6845 549.141V477.733C31.6845 474.446 34.3487 471.782 37.6352 471.782Z",
    fill: "#313131"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolDirectionIcon);
export default __webpack_public_path__ + "static/media/tool-direction-icon.6b547667.svg";
export { ForwardRef as ReactComponent };